import React, { useState } from 'react';
import * as actions from "../../redux/actions";
import { useSelector, useDispatch } from "react-redux";
import { sendAnalyticsData } from "../../utility/levarAnalytics";
import { handleWebViewDetect } from "../../utility/featureDetection";
const BUCKET_URL = process.env.REACT_APP_BUCKET_URL_AR;

const LaunchButton = () => {
  const [loading, setLoading] = useState(false);

  const { engine, session_id, hash, variant, referrer, product_id } = useSelector(state => ({
    engine: state.engine,
    session_id: state.session_id,
    hash: state.hash,
    variant: state.variant,
    referrer: state.referrer,
    product_id: state.product_id,
  }));

  const dispatch = useDispatch();

  const handleLaunchAR = async (e) => {
    const webCheck = handleWebViewDetect();

    if (webCheck === true) {
      dispatch(actions.setPromptView(false));
      dispatch(actions.setWebViewPrompt(true));
      return
    }

    e.preventDefault()
    setLoading(true);
    if(session_id) await sendAnalyticsData({ session_id, hash, variant, event_type: 'view_ar_launch', referrer, product_id });

    const anchor = document.createElement('a');
    anchor.setAttribute('rel', 'ar');
    anchor.appendChild(document.createElement('img'));

    let updatedUrl = handleViewerUrl();
    anchor.setAttribute('href', updatedUrl);

    setTimeout(() => {
      anchor.click();
      setLoading(false);
    }, 1500);
  };

  const handleViewerUrl = () => {
    let finalUrl = "";

    if(engine.quickLook) {
      finalUrl = `${BUCKET_URL}${hash}.usdz#allowsContentScaling=0`;
    } else if(engine.sceneViewer) {
      let glbURL = `${BUCKET_URL}${hash}.glb`;
      let sceneURL = "#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=https://developers.google.com/ar;end;"
      finalUrl = `intent://arvr.google.com/scene-viewer/1.0?file=${glbURL}&mode=ar_only&resizable=false${sceneURL}`;
    }

    return finalUrl
  };

  return (
    <React.Fragment>
      <button onClick={(e) => handleLaunchAR(e)} className="LaunchButton">
        {
          !loading ? (
            <span>Launch AR</span>
          ) : ( <div className="Loader-Spinner"></div> )
        }
      </button>
    </React.Fragment>
  );
};

export default LaunchButton;
